import React, { useState, useEffect } from 'react';
import './NavbarDashboard.css';
import { Link as Anchor, useLocation, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp, faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import { faGauge, faStore, faList, faRectangleList, faImage, faTag, faUser, faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { faProductHunt } from '@fortawesome/free-brands-svg-icons';
import { fetchUsuario, getUsuario } from '../../user';
import logo from '../../../images/logo.png';
import baseURL from '../../url';

export default function Navbar() {
    const location = useLocation();
    const [tienda, setTienda] = useState([]);
    const [expanded, setExpanded] = useState(false);
    const [detallesVisibles, setDetallesVisibles] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth <= 1024) {
                setExpanded(false);
            }
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => { cargarTienda(); }, []);

    const cargarTienda = () => {
        fetch(`${baseURL}/tiendaGet.php`)
            .then(r => r.json())
            .then(d => setTienda(d.tienda?.reverse()[0] || []))
            .catch(e => console.error('Error al cargar datos:', e));
    };

    const [loading, setLoading] = useState(true);
    useEffect(() => {
        (async () => { await fetchUsuario(); setLoading(false); })();
    }, []);

    const usuarioLegued = getUsuario();
    const isActive = (path) => location.pathname === path ? 'activeLink' : '';

    const handleLogout = async () => {
        try {
            await fetch(`${baseURL}/logout.php`);
            window.location.reload();
        } catch (e) { console.error(e); }
    };

    const links = [
        { to: '/dashboard', icon: faGauge, label: 'Dashboard' },
        { to: '/dashboard/categorias', icon: faList, label: 'Categorías' },
        { to: '/dashboard/productos', icon: faProductHunt, label: 'Productos' },
        { to: '/dashboard/pedidos', icon: faRectangleList, label: 'Pedidos' },
        { to: '/dashboard/banners', icon: faImage, label: 'Banners' },
        { to: '/dashboard/promociones', icon: faTag, label: 'Promociones' },
        { to: '/dashboard/usuarios', icon: faUser, label: 'Usuarios' },
        { to: '/dashboard/metodos-de-pago', icon: faRectangleList, label: 'Metodos' },
    ];

    const linksColab = [
        { to: '/dashboard', icon: faGauge, label: 'Dashboard' },
        { to: '/dashboard/categorias', icon: faList, label: 'Categorías' },
        { to: '/dashboard/productos', icon: faProductHunt, label: 'Productos' },
        { to: '/dashboard/pedidos', icon: faRectangleList, label: 'Pedidos' },
         { to: '/dashboard/metodos-de-pago', icon: faRectangleList, label: 'Metodos' },
    ];

    const linksBasic = [
        { to: '/dashboard', icon: faGauge, label: 'Dashboard' },
        { to: '/dashboard/pedidos', icon: faRectangleList, label: 'Pedidos' },
    ];

    const navLinks = loading || !usuarioLegued?.idUsuario ? (
        [...links.slice(0, 2), { to: '/dashboard/mi-tienda', icon: faStore, label: 'Tienda' }, ...links.slice(2)]
    ) : usuarioLegued?.rol === 'admin' ? links :
      usuarioLegued?.rol === 'colaborador' ? linksColab : linksBasic;

    const showStore = loading || !usuarioLegued?.idUsuario || usuarioLegued?.rol === 'admin';

    return (
        <div className={`navbarDashboard ${expanded ? 'expanded' : 'collapsed'}`}>
            <div className='logo'>
                <div className='logo-inner'>
                    {tienda?.imagen1 ? <img src={tienda.imagen1} alt="" /> : <img src={logo} alt="" />}
                    <div className='deColumnNav'>
                        <ss>{tienda?.nombre || 'Tienda'}</ss>
                        <ss>{tienda?.email || 'email@tienda.com'}</ss>
                    </div>
                </div>
                <button className="nav_toggle2" onClick={() => setExpanded(!expanded)}>
                    <span></span><span></span><span></span>
                </button>
            </div>

            <div className='links'>
                {navLinks.map(l => (
                    <Anchor key={l.to} to={l.to} className={isActive(l.to)}>
                        <FontAwesomeIcon icon={l.icon} /> <span className="nav-label">{l.label}</span>
                    </Anchor>
                ))}

               
            </div>

            <div className='logout-wrap'>
                <Anchor onClick={handleLogout}>
                    <FontAwesomeIcon icon={faSignOutAlt} /> <span className="nav-label">Cerrar sesión</span>
                </Anchor>
            </div>
        </div>
    );
}
